import { render, staticRenderFns } from "./GoodBooks.vue?vue&type=template&id=41d36056&scoped=true"
import script from "./GoodBooks.vue?vue&type=script&lang=js"
export * from "./GoodBooks.vue?vue&type=script&lang=js"
import style0 from "./GoodBooks.vue?vue&type=style&index=0&id=41d36056&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d36056",
  null
  
)

export default component.exports